const findExistingSlot = (slots, adId) =>
  slots.find(slot => slot.getSlotElementId() === adId) || false;

export default findExistingSlot;
